import styled from "styled-components";

export const LiveCasinoGridItemBetBehindButtonDefaultBox = styled.div`
    display: flex;
    box-sizing: border-box;
    height: 2em;
    padding: 0 1.25em;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    color: ${props => props.theme.colors.brandSecondary};
    background: ${props => props.theme.colors.background};
    border: 1px solid;
    text-transform: uppercase;
    border-radius: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.2em;

    &:hover {
        color: ${props => props.theme.colors.backgroundDark};
        background: ${props => props.theme.colors.brandSecondary};
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        padding: 0.25em;
        background: transparent;
        border: none;
        font-weight: 300;
        line-height: 1;
        font-size: 1.1em;

        &:hover {
            color: ${props => props.theme.colors.brandSecondary};
        }
    }
`;